<template>
  <div>
    <div class="main-content bg-white" v-if="$currentUser.role == 'account'">
      <span class="alert-danger">У вас нет доступа к этой странице.</span>
    </div>
    <div class="main-content bg-white" v-if="$currentUser.role != 'account'">
      <div class="page-header">
        <h3 class="page-title">Рекламодатели</h3>
      </div>
      <div class="row mb-2">
        <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2">
          <b-btn size="sm" variant="success" style="white-space: nowrap;" class="mainButton filterComponent"
                 v-b-modal.createAdvertiser>
            Создать рекламодателя
          </b-btn>
        </div>
          <div class="col-sm-3 col-md-3 col-lg-2 col-xl-2 mb-2" v-if="!isMobile">
              <b-button-group class="filterComponent" style="width: 100%!important;">
                  <b-button variant="success" class="mr-1" v-on:click="selectAll"
                            size="sm">
                      <i class="icon-fa icon-fa-check-square-o"></i>
                  </b-button>
                  <b-button variant="danger" class="mr-1" v-on:click="diselectAll"
                            size="sm">
                      <i class="icon-fa icon-fa-close"></i>
                  </b-button>
                  <b-button variant="primary" class="mr-1" v-on:click="editSelected()"
                            size="sm">
                      <i class="icon-fa icon-fa-edit"></i>
                  </b-button>
              </b-button-group>
          </div>
        <div class="col-sm-4 col-md-3 col-lg-3 col-xl-2">
          <b-button variant="warning" size="sm">
            <a
                v-bind:href="getExcelParamsString()">
              Выгрузить xls <i class="icon-fa icon-fa-upload"></i>
            </a>
          </b-button>
        </div>
      </div>
      <div class="row mb-2">
        <div class="col-sm-4 col-md-3 col-lg-2 col-xl-2 mb-2">
          <b-form-input placeholder="Поиск:"
                        size="sm"
                        class="filterComponent"
                        v-model="search"></b-form-input>
        </div>

        <div class="col-sm-5 col-md-3 col-lg-2 col-xl-2 mb-2">
          <b-input-group class="filterComponent">
            <div></div>
            <b-input-group-append>
              <b-btn size="sm" text="Search" variant="success"
                     class="mainButton"
                     style="margin-right: 4px; border-top-left-radius: 0.2rem; border-bottom-left-radius: 0.2rem;"
                     @click="getAdvertisers(1, {sortBy: sortBy, sortDesc: sortDesc}, search)">
                Применить
              </b-btn>
              <b-btn size="sm" variant="outline-danger" class="mainButton" @click="resetFilters">
                Очистить
              </b-btn>
            </b-input-group-append>
          </b-input-group>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <div v-if="!isMobile">
            <b-table hover responsive bordered
                     selectable
                     ref="selectableTable"
                     small
                     :items="advertisers"
                     :fields="fields"
                     no-local-sorting
                     :sort-by.sync="sortBy"
                     @row-clicked="rowClickHandler"
                     @sort-changed="getAdvertisers(1, $event, search)"
                     :sort-desc.sync="sortDesc"
                     :sort-direction="sortDirection">
              <template v-slot:cell(channel)="row">
                <span v-if="row.item.channel">{{ channels[row.item.channel] }}</span>
              </template>
                <template v-slot:cell(sales_managers)="row">
                    <span>{{ row.item.sales_managers_parsed }}</span>
                </template>
              <template v-slot:cell(account_manager)="row">
                <span v-if="row.item.account_manager">{{ row.item.account_manager.name }}</span>
              </template>
              <template v-slot:cell(creator)="row">
                <span v-if="row.item.creator">{{ row.item.creator.name }}</span>
              </template>
              <template v-slot:cell(actions)="row">
                <b-button size="sm" class="btn btn-primary"
                          style="color: #fff;background-color: #007dcc;border-color: #007dcc;"
                          @click.stop="showHistory(row)">
                  <i class="icon-fa icon-fa-eye"></i>
                </b-button>
                <b-button size="sm" class="btn btn-warning"
                          @click.stop="edit(row)">
                  <i class="icon-fa icon-fa-edit"></i>
                </b-button>
                <b-button size="sm" class="btn btn-danger"
                          @click.stop="deleteAdvertiser(row.item)">
                  <i class="icon-fa icon-fa-trash-o"></i>
                </b-button>
              </template>
            </b-table>
          </div>
          <div v-if="isMobile">
            <b-table hover responsive bordered stacked
                     small
                     :items="advertisers"
                     :fields="fields"
                     no-local-sorting
                     :sort-by.sync="sortBy"
                     @sort-changed="getAdvertisers(1, $event, search)"
                     :sort-desc.sync="sortDesc"
                     :sort-direction="sortDirection">
              <template v-slot:cell(channel)="row">
                <span v-if="row.item.channel">{{ channels[row.item.channel] }}</span>
              </template>
              <template v-slot:cell(sales_managers)="row">
                <span >{{ row.item.sales_managers_parsed }}</span>
              </template>
              <template v-slot:cell(actions)="row">
                <b-button size="sm" class="btn btn-primary"
                          style="color: #fff;background-color: #007dcc;border-color: #007dcc;"
                          @click.stop="showHistory(row)">
                  <i class="icon-fa icon-fa-eye"></i>
                </b-button>
                <b-button size="sm" class="btn btn-warning"
                          @click.stop="edit(row)">
                  <i class="icon-fa icon-fa-edit"></i>
                </b-button>
                <b-button size="sm" class="btn btn-danger"
                          @click.stop="deleteAdvertiser(row.item)">
                  <i class="icon-fa icon-fa-trash-o"></i>
                </b-button>
              </template>

            </b-table>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-5">
          <div class="" role="status" aria-live="polite">Всего записей: {{ pager.total }}</div>
        </div>
        <div class="col-sm-7">
          <div class="float-right">
            <nav aria-label="Page navigation">
              <ul class="pagination justify-content-center">
                <b-pagination size="sm" :total-rows="pager.total"
                              v-model="pager.current_page"
                              v-on:change="getAdvertisers($event, {sortBy: sortBy, sortDesc: sortDesc}, search)"
                              :per-page="pager.per_page">

                </b-pagination>
              </ul>
            </nav>
          </div>
        </div>
      </div>
      <b-modal id="createAdvertiser"
               :no-close-on-backdrop="true"
               :no-enforce-focus="true"
               :no-close-on-esc="true"
               ref="advertiserCreateModal" size="md" title="Создать рекламодателя" @hidden="hideCreateModal"
               hide-footer>
        <CreateAdvertiserModal></CreateAdvertiserModal>
      </b-modal>
        <b-modal ref="MassEditAdvertisersModal"
                 :no-close-on-backdrop="true"
                 :no-enforce-focus="true"
                 :no-close-on-esc="true"
                 @hide="getAdvertisers()"
                 id="MassEditAdvertisersModal" size="md" title="Редактировать рекламодателей" hide-footer>
            <MassUpdateAdvertisersModal v-bind:advertisers="selectedAdvertisers"></MassUpdateAdvertisersModal>
        </b-modal>
      <b-modal ref="advertiserEditModal"
               :no-close-on-backdrop="true"
               :no-enforce-focus="true"
               :no-close-on-esc="true"
               id="advertiserEditModal" size="md" title="Редактировать рекламодателя" hide-footer>
        <EditAdvertiserModal :advertiser="selectedAdv"></EditAdvertiserModal>
      </b-modal>

      <b-modal ref="advertiserShowAccountHistoryModal"
               :no-close-on-backdrop="true"
               :no-enforce-focus="true"
               :no-close-on-esc="true"
               id="advertiserShowAccountHistoryModal" size="lg" title="История изменения дат действия аккаунт менеджера" hide-footer>
        <AccountHistoryModal :advertiser="selectedAdv"></AccountHistoryModal>
      </b-modal>
    </div>
  </div>
</template>
<script>

import CreateAdvertiserModal from "./modals/CreateAdvertiserModal"
import EditAdvertiserModal from './modals/EditAdvertiserModal'
import MassUpdateAdvertisersModal from './modals/MassUpdateAdvertisersModal'

import AccountHistoryModal from './modals/AccountHistoryModal'
import AdvertisersService from '../../services/advertisersDataService'
import {ru} from '../../services/customLocaleDatepicker'
import saveFiltersMixin from "./mixins/saveFiltersMixin";
import Ls from '../../services/ls'
import MassEditConversionsModal from "./modals/MassUpdateConversionsModal.vue";

export default {
  name: 'advertisers',
  components: {
      MassEditConversionsModal,
    CreateAdvertiserModal: CreateAdvertiserModal,
    EditAdvertiserModal: EditAdvertiserModal,
    AccountHistoryModal: AccountHistoryModal,
      MassUpdateAdvertisersModal: MassUpdateAdvertisersModal
  },
  mixins: [saveFiltersMixin],
  data() {
    return {
      advertisers: [],
      pager: {},
      pageSize: 50,
      channels: {
          'conference': 'Конференция',
          'networking': 'Нетворкинг',
          'recommendation': 'Рекомендация',
          'coldsale': 'Холодные продажи',
          'website': 'Запрос через сайт/соц.сети'
      },
      fields: [
        {
          key: 'id',
          label: 'ID',
          sortable: true
        },
        {
          key: 'legal_title',
          label: 'Официальное Название',
          sortable: true
        },
        {
          key: 'title',
          label: 'Псевдоним',
          sortable: false,
        },
        {
          key: 'sales_managers',
          label: 'Сейлз Менеджеры',
          sortable: false,
        },
        {
          key: 'account_manager',
          label: 'Аккаунт Менеджер',
          sortable: false,
        },
        {
          key: 'creator',
          label: 'Создатель',
          sortable: false,
        },
        {
          key: 'created_at',
          label: 'Дата создания',
          sortable: true,
        },
        {
          key: 'actions',
          label: 'Действия',
          tdAttr: {'align': "center"}
        }
      ],
      search: '',
      sortBy: 'created_at',
      sortDesc: true,
      sortDirection: 'desc',

      selectedAdv: null,
      isMobile: false,
      window: {
        width: 0,
        height: 0
      },
      isXl: false,
      ru: ru,
      savedFiltersName: 'advertisers',
        selectedAdvertisers: {}
    }
  },
  methods: {
    getAdvertisers(page, sort, search) {
      if (this.useSavedFilters == true) {
        let filters = this.getFilters(this.savedFiltersName)

        if (filters) {
            page = filters.page
            this.sortBy = filters.sortBy
            this.sortDesc = filters.sortDesc
            this.search = filters.search
            this.pageSize = filters.pageSize
        }
      }

      if (!page) {
        page = 1;
      }

      if (!sort) {
        sort = {
          sortBy: this.sortBy,
          sortDesc: this.sortDesc,
        };
      }

      if (!search) {
        search = this.search ? this.search : null
      }

      if (this.isMobile) {
        this.pageSize = 10;
      }

      let params = {
        page: page,
        sortBy: sort.sortBy,
        sortDir: sort.sortDesc === true ? 'desc' : 'asc',
        search: search,
        pageSize: this.pageSize,
      }

      if (params.sortBy === '') {
        return
      }

      this.saveFilters(this.savedFiltersName, this.stringify(params))

      AdvertisersService.getPaginatedAdvertisers(params)
        .then(advertisers => {
            advertisers.data.forEach(function (advertiser) {
                let salesManagers = advertiser.sales_managers

                let salesManagersArray = []
                let salesManagersString = '';

                if (salesManagers.length > 0) {
                  salesManagers.forEach(function (salesManager) {
                    salesManagersArray.push(salesManager.name)
                  });

                  salesManagersString = salesManagersArray.toString().split(', ').toString()
                }

                advertiser.sales_managers_parsed = salesManagersString
            });

            this.pager = advertisers;
            this.advertisers = advertisers.data
            this.useSavedFilters = false
        })

    },
    getExcelParamsString() {
      let params = {
        token: Ls.get('auth.token'),
        sortBy: this.sortBy,
        sortDesc: this.sortDesc,
        search: this.search
      }

      return '/advertisers/export?' + new URLSearchParams(params).toString();
    },
    selectRange(event) {
      this.range = event;
    },
      selectAll() {
          this.isSelectAll = true

          this.advertisers.forEach((row, index) => {
            this.$refs.selectableTable.selectRow(index)
            this.selectedAdvertisers[row.id] = true
          })
      },
      diselectAll() {
          this.isSelectAll = false
          this.$refs.selectableTable.clearSelected()

          this.advertisers.forEach(function (item) {
              this.selectedAdvertisers[item.id] = false
          }.bind(this))
      },
      editSelected() {
          this.$refs.MassEditAdvertisersModal.show()
      },
    resetFilters() {
      this.search = '';
      this.sortBy = 'created_at';
      this.sortDesc = true;
      this.sortDirection = 'desc';
      this.getAdvertisers();
    },
      rowClickHandler(row, index) {
          if (this.$refs.selectableTable.isRowSelected(index)) {
              // this.$refs.selectableTable.unselectRow(index)
              this.selectedAdvertisers[row.id] = false
              return
          }

          // this.$refs.selectableTable.selectRow(index)
          this.selectedAdvertisers[row.id] = true
      },
      edit(row) {
      this.selectedAdv = row.item
      this.$refs.advertiserEditModal.show()
    },
      showHistory(row) {
          this.selectedAdv = row.item
          this.$refs.advertiserShowAccountHistoryModal.show()
      },

    deleteAdvertiser(advertiser) {
      this.$bvModal.msgBoxConfirm('ID: ' + advertiser.id + ' Название: ' + advertiser.legal_title , {
        title: 'Вы точно уверены, что хотите удалить?',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'ДА',
        cancelTitle: 'НЕТ',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if(value !== true) {
            return
          }

          if(! confirm('Точно удаляем?')) {
            return;
          }

          AdvertisersService.deleteAdvertiser(advertiser.id)
            .then(response => {
              if (response.status === true) {
                this.getAdvertisers();
                toastr.success('Рекламодатель удалён!')
              } else {
                toastr.error('Вы не можете удалить этого Рекламодателя. К нему привязаны оффера.')
              }
            })
        })
        .catch(err => {
        })

    },

    handleResize() {
      this.window.width = window.innerWidth;
      this.window.height = window.innerHeight;

      this.isMobile = this.window.width < 415;
      this.isXl = this.window.width > 1199;
    },

    hideCreateModal() {
      this.getAdvertisers();
      this.$refs.advertiserCreateModal.hide()
    },
      getAdkeyFields () {
        return [
            {
                key: 'id',
                label: 'ID',
                sortable: true
            },
            {
                key: 'legal_title',
                label: 'Официальное Название',
                sortable: true
            },
            {
                key: 'title',
                label: 'Псевдоним',
                sortable: false,
            },
            {
                key: 'channel',
                label: 'Канал продаж',
                sortable: false,
            },
            {
                key: 'sales_managers',
                label: 'Сейлз Менеджеры',
                sortable: false,
            },
            {
                key: 'account_manager',
                label: 'Аккаунт Менеджер',
                sortable: false,
            },
            {
                key: 'creator',
                label: 'Создатель',
                sortable: false,
            },
            {
                key: 'created_at',
                label: 'Дата создания',
                sortable: true,
            },
            {
                key: 'actions',
                label: 'Действия',
                tdAttr: {'align': "center"}
            }
        ];
      }

  },

  beforeMount() {
    this.useSavedFilters = true

    this.getAdvertisers()

      if (this.$currentUser.department === 'adkey') {
        this.fields = this.getAdkeyFields()
      }
  },

  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize();
  },

  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  },
}
</script>
<style>
.btn i {
  text-align: center !important;
}

.popover-body {
  max-height: 200px;
  overflow: scroll;
}

.vdp-datepicker input {
  background-color: white !important;
  width: 100% !important;
}

.dateFrom {
  border-bottom-right-radius: 0 !important;
  border-top-right-radius: 0 !important;
}

.dateTo {
  border-bottom-left-radius: 0 !important;
  border-top-left-radius: 0 !important;
}

.filterComponent {
  height: 30px !important;
}

.filterComponent .vs__dropdown-toggle {
  height: 30px !important;
}

.filterComponent .input-date {
  height: 30px !important;
}

.filterComponent .dateFrom {
  height: 30px !important;
}

.filterComponent .dateTo {
  height: 30px !important;
}

.input-date {
  border-top-left-radius: 0.2rem !important;
  border-bottom-left-radius: 0.2rem !important;
}

.mainButton {
  width: 100%;
}

.date {
  width: 100%;
}

.datePickerXl {
  min-width: 100% !important;
  max-width: 100% !important;
}

.myAdv {
  padding-top: 4px;
}

.groupComponent .vs__selected {
  margin: 2px 2px 4px 0 !important;
}

.table-sm th {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}

.table.b-table > tfoot > tr > th[aria-sort]::before, .table.b-table > thead > tr > th[aria-sort]::before {
  padding-left: 5px;
  width: .2em;
}

@media (max-width: 575px) {
  .dateRight .vdp-datepicker__calendar {
    right: 0 !important;
  }

}

@media (max-width: 652px) {
  .dateRight .vdp-datepicker__calendar {
    right: 0 !important;
  }

  .myAdv {
    min-width: 40% !important;
  }
}

@media (min-width: 768px) {
  .dateLeft .vdp-datepicker__calendar {
    right: 0 !important;
  }

  .dateRight .vdp-datepicker__calendar {
    right: 0 !important;
  }

  .myAdv {
    min-width: 28.5% !important;
  }

}

@media (min-width: 1200px) {
  .myAdv {
    min-width: 18% !important;
  }

  .input-date {
    width: 146px !important;
  }

}

@media (min-width: 1300px) {
  .input-date {
    width: 160px !important;
  }

  .myAdv {
    min-width: 16% !important;
  }
}

@media (min-width: 1400px) {
  .input-date {
    width: 170px !important;
  }

  .myAdv {
    min-width: 15% !important;
  }
}

@media (min-width: 1500px) {
  .input-date {
    width: 190px !important;
  }

  .myAdv {
    min-width: 14% !important;
  }
}

@media (min-width: 1600px) {
  .input-date {
    width: 200px !important;
  }

  .myAdv {
    min-width: 13% !important;
  }

}

@media (min-width: 1700px) {
  .input-date {
    width: 220px !important;
  }

  .myAdv {
    min-width: 12% !important;
  }
}

@media (min-width: 1800px) {
  .input-date {
    width: 230px !important;
  }

  .myAdv {
    min-width: 11% !important;
  }
}

@media (min-width: 1900px) {
  .input-date {
    width: 240px !important;
  }

  .myAdv {
    min-width: 10% !important;
  }

}

</style>



// WEBPACK FOOTER //
// resources/js/views/front/Advertisers.vue